import React from "react";

const diagramNodes = [
  { id: "H", x: 500, y: 100, color: "green" },
  { id: "G", x: 500, y: 280, color: "green" },
  { id: "J", x: 825, y: 380, color: "green" },
  { id: "E", x: 350, y: 480, color: "green" },
  { id: "I", x: 500, y: 480, color: "green" },
  { id: "F", x: 650, y: 480, color: "green" },
  { id: "A", x: 200, y: 700, color: "purple" },
  { id: "B", x: 500, y: 700, color: "purple" },
  { id: "C", x: 800, y: 700, color: "purple" },
  { id: "D", x: 950, y: 700, color: "purple" },
  { id: "K", x: 350, y: 920, color: "red" },
  { id: "O", x: 500, y: 920, color: "red" },
  { id: "L", x: 650, y: 920, color: "red" },
  { id: "M", x: 500, y: 1120, color: "red" },
  { id: "P", x: 200, y: 1120, color: "red" },
  { id: "N", x: 500, y: 1300, color: "red" },
  { id: "Q", x: 350, y: 1480, color: "red" },
  { id: "R", x: 500, y: 1480, color: "red" },
  { id: "S", x: 650, y: 1480, color: "red" }
];

const colorTokens = {
  purple: { fill: "#b794c0", stroke: "#967aa0", text: "#fff" },
  green: { fill: "#cddc39", stroke: "#afb42b", text: "#333" },
  red: { fill: "#ef5350", stroke: "#d32f2f", text: "#fff" }
};

const bgHaloColor = "#e5e7eb";

const PinnacleDiagram = ({ results }) => {
  const getValue = (id) => {
    if (!results) return "—";
    const value = results[id];
    return value === null || value === undefined ? "—" : value;
  };

  const Line = ({ from, to }) => {
    const start = diagramNodes.find((n) => n.id === from);
    const end = diagramNodes.find((n) => n.id === to);
    if (!start || !end) return null;
    return (
      <line
        x1={start.x}
        y1={start.y}
        x2={end.x}
        y2={end.y}
        stroke="#1e40af"
        strokeWidth="5"
        strokeLinecap="round"
        className="transition-all duration-500 ease-in-out hover:stroke-morado hover:stroke-[8px] cursor-pointer opacity-80 hover:opacity-100"
      />
    );
  };

  return (
    <div className="w-full h-full bg-gray-200 rounded-2xl shadow-inner p-4 flex items-center justify-center">
      <svg viewBox="0 0 1000 1600" className="w-full h-auto drop-shadow-xl select-none">
        <g opacity="0.8">
          <Line from="H" to="A" />
          <Line from="H" to="J" />
          <Line from="J" to="D" />

          <Line from="A" to="B" />
          <Line from="B" to="C" />
          <Line from="C" to="D" />
          <Line from="A" to="E" />
          <Line from="B" to="E" />
          <Line from="B" to="F" />
          <Line from="C" to="F" />
          <Line from="E" to="G" />
          <Line from="F" to="G" />
          <Line from="G" to="H" />
          <Line from="I" to="E" />
          <Line from="I" to="F" />
          <Line from="I" to="B" />
          <Line from="I" to="A" />
          <Line from="I" to="C" />

          <Line from="A" to="K" />
          <Line from="B" to="K" />
          <Line from="B" to="L" />
          <Line from="C" to="L" />
          <Line from="K" to="M" />
          <Line from="L" to="M" />
          <Line from="B" to="O" />
          <Line from="O" to="M" />
          <Line from="A" to="P" />
          <Line from="M" to="N" />
          <Line from="P" to="Q" />
          <Line from="N" to="R" />
          <Line from="N" to="S" />
        </g>

        {diagramNodes.map((node) => {
          const style = colorTokens[node.color] || colorTokens.purple;
          const value = getValue(node.id);

          return (
            <g
              key={node.id}
              className="group cursor-pointer transition-transform duration-300 ease-out hover:scale-110"
              style={{ transformOrigin: `${node.x}px ${node.y}px` }}
            >
              <circle
                cx={node.x + 5}
                cy={node.y + 5}
                r="50"
                fill="rgba(0,0,0,0.2)"
                className="transition-all duration-300 group-hover:translate-x-1 group-hover:translate-y-1 group-hover:fill-black/30"
              />
              <circle
                cx={node.x}
                cy={node.y}
                r="50"
                fill={style.fill}
                stroke={style.stroke}
                strokeWidth="3"
                className="transition-all duration-300 group-hover:brightness-110 group-hover:stroke-[4px]"
              />
              <g transform={`translate(0, 85)`}>
                <text
                  x={node.x}
                  y={node.y}
                  textAnchor="middle"
                  stroke={bgHaloColor}
                  strokeWidth="15"
                  strokeLinejoin="round"
                  className="text-2xl font-bold font-sans"
                  style={{ paintOrder: "stroke" }}
                >
                  {node.id}
                </text>
                <text
                  x={node.x}
                  y={node.y}
                  textAnchor="middle"
                  fill="#374151"
                  className="text-2xl font-bold font-sans transition-colors duration-300 group-hover:fill-black"
                >
                  {node.id}
                </text>
              </g>
              <text
                x={node.x}
                y={node.y + 18}
                textAnchor="middle"
                fill={style.text}
                className="text-5xl font-bold font-sans"
                style={{ textShadow: "1px 1px 2px rgba(0,0,0,0.2)" }}
              >
                {value}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
};

export default PinnacleDiagram;

